export default "https://cdn.questicon.mathletics.com/assets/images/SUMMIT-FG-7e3ccce0deb834dcee78d96977fbbdec.svg";